import { Container, Typography, Button, Box, useTheme } from '@mui/material';

import { getStyled } from './styles';

const ForbiddenPage = () => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Container sx={classes.container}>
      <Box sx={classes.boxContainer}>
        <Box>
          <Typography variant='h1' sx={classes.title} color='error'>
            403
          </Typography>
          <Typography variant='h5' color='textSecondary'>
            Oops! Acesso Negado!
          </Typography>
          <Button
            sx={classes.button}
            variant='outlined'
            color='primary'
            href='/tickets'
          >
            Voltar
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ForbiddenPage;
